import React from 'react';
import '@elastic/eui/dist/eui_theme_light.css';
import { EuiText, EuiFlexGroup, EuiFlexItem, EuiSpacer, EuiPageTemplate, EuiPageHeader, EuiImage } from '@elastic/eui';
import styled from 'styled-components';
import { Header } from '../components/header';
import { Footer } from '../components/footer';
import project1image1 from '../../documents/project1image1.png'
import project1image2 from '../../documents/project1image2.png'

const StyledText = styled.div`
  ul.skills-list {
    display: grid;
    grid-gap: 0 10px;
    padding: 0;
    overflow: hidden;
    list-style: none;

    li {
      position: relative;
      font-family: var(--font-mono);
      font-size: var(--fz-xs);

      &:before {
        content: '• ';
        left: 0;
        color: var(--green);
        font-size: var(--fz-sm);
        line-height: 12px;
      }
    }
  }
`;
class Project1 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            data: [],
            isModalVisible: false,
            files: {},
            uploadDisabled: true,
            selection: [],
            columns: [],
            AlertText: "",
            AlertType: "error",
            project1Objective: "To design a tailor-made, cost effective indigenous rebar tie tool for current Indian construction sites",
            project1Key: ['Rigorous literature review and market survey', 'Alpha models manufactured and tested on 10+ sites', 'Compared 8 different tools on various points', 'Future Scope - Patentability', 'Conceptualized two innovative designs', 'Ball bearing mechanized ergonomically designed', 'Pneumatic / simple electric motor', 'Hands-on experience on  various rebar tie tools'],
            project1Value: ['Exposure to product development', 'Market Research', 'Proposal Writing'],
    }
    }

    render() {

        return (
            <>
                <EuiPageTemplate>
                    <EuiPageHeader><Header /></EuiPageHeader>
                    <EuiSpacer />
                        <EuiText><h2><font face='Segoe UI'>Spinning - Rebar Tie tool
                        </font></h2></EuiText>
                        <EuiSpacer size='m' />
                        <EuiText><h5><font face='Segoe UI'>Advisor - PI: - Prof. Dr. Archana Tanawade, Co-PI: - Hemant Dhonde  &emsp; &emsp; &emsp; &emsp; &emsp;&emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp;February 2020- March 2021</font></h5></EuiText>
                        <EuiSpacer size='m' />
                        <EuiSpacer />
                        <EuiText><b>Position:</b> &emsp;  Undergraduate Researcher</EuiText><EuiSpacer/>
                <EuiFlexGroup gutterSize='xl'>
                <EuiFlexItem><EuiText><b>Research Objectives</b><br/>
                        {this.state.project1Objective}<EuiSpacer/>
                        <b>Project Highlights</b>
                        <StyledText><ul className="skills-list">
                        {this.state.project1Key && this.state.project1Key.map((p, i) => <li key={i}>{p}</li>)}
                        </ul></StyledText>
                        <b>Value Additions </b>
                        <StyledText><ul className="skills-list">
                        {this.state.project1Value && this.state.project1Value.map((p, i) => <li key={i}>{p}</li>)}
                        </ul></StyledText>
                        </EuiText>
                </EuiFlexItem><div><EuiFlexGroup direction='column'>
                <EuiFlexItem ><EuiText textAlign='center'>
                  <EuiImage size='m' src={project1image1} /><br/>Conventional Hook<br/><br/>
                <EuiImage size='l' src={project1image2} /><br/>
                Rebar Tie Tool</EuiText></EuiFlexItem></EuiFlexGroup></div>
                </EuiFlexGroup>
            <Footer /></EuiPageTemplate>
            </>
        )
    }
};

export { Project1 }